import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

// Caja para texto
export const StyledBoxText = styled.div`
  align-items: left;
  background-color: ${props => props.theme.colors.dark}B5;
  bottom: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 0 12.5% 0 12.5%;
  position: absolute;
  transform: translate3d(0, 100%, 0);
  transition: all 0.3s ease-in 0s;
  width: 100%;
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('110px')};
    padding: 0 0 0 ${rem('41px')};
  `};
`;

// Título texto
export const StyledText = styled.h4`
  color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.medium};
  line-height: ${rem('19px')};
  margin-bottom: ${rem('4px')};
  @media (orientation: landscape) {
    font-size: ${rem('22px')};
    margin-bottom: ${rem('10px')};
  }
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('19px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('16px')};
    margin-bottom: ${rem('6px')};
  `};
`;

// Párrafo
export const StyledParagraph = styled.p`
  color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('13px')};
  line-height: ${rem('17px')};
  margin-bottom: ${rem('8px')};
  @media (orientation: landscape) {
    font-size: ${rem('16px')};
  }
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('17px')};
    font-family: ${props => props.theme.fonts.book};
    margin-bottom: ${rem('16px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${props => props.theme.fontSize.small};
    margin-bottom: ${rem('4px')};
  `};
`;

// Autor de la foto
export const StyledAuthor = styled.span`
  color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  ${mediaqueries.greaterThan('desktop')`
    font-family: ${props => props.theme.fonts.book};
  `};
`;
